import {
  AiOutlineHome,
  AiOutlineClose,
  AiOutlineEdit,
  AiOutlineMenu,
} from 'react-icons/ai';
import {
  IoLogOutOutline,
  IoSettingsOutline,
  IoCameraOutline,
  IoPersonOutline,
} from 'react-icons/io5';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import {
  Container,
  Flex,
  Box,
  Center,
  Text,
  Img,
  Circle,
  List,
  ListItem,
  Icon,
  IconButton,
  Spinner,
} from '@chakra-ui/react';
import Swal from 'sweetalert2';
import { IoBarChartOutline } from 'react-icons/io5'; 
import * as api from '../../api/imagemPerfil';
import './sidebar.scss';
import { Content } from '../Icons';
import { useAuth } from '../../contexts/AuthContext';

interface MenuItem {
  icon: (color: string) => JSX.Element;
  seqPerfilMenu: number;
  dscMenu: string;
  numRegistro: number;
  path: string;
}

const Sidebar = () => {
  const { logout } = useAuth();
  const [isSidebarAberta, setIsSidebarAberta] = useState<boolean>(true);
  const [nomeUsuario, setNomeUsuario] = useState<string | undefined>(undefined);
  const [fotoPerfil, setFotoPerfil] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [idUsuario, setIdUsuario] = useState<string | undefined>(undefined);
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [imagemUsuario, setImagemUsuario] = useState<File | null>(null);

  const navigate = useNavigate();
  const location = useLocation();
  const [permisssaoAcessoCodMenuNulo, setPermisssaoAcessoCodMenuNulo] = useState<MenuItem[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const refreshFotoPerfil = () => {
      const dadosLocalStorage = localStorage.getItem("dadosUsuario");
      if (dadosLocalStorage) {
        try {
          const usuario = JSON.parse(dadosLocalStorage);
          if (usuario.imagemPerfil && usuario.imagemPerfil.trim() !== '') {
            setFotoPerfil(atualizarPreview(usuario.imagemPerfil));
          } else {
            setFotoPerfil('');
          }
        } catch (error) {
          console.error("Erro ao atualizar a foto de perfil:", error);
        }
      }
    };
    window.addEventListener("focus", refreshFotoPerfil);
    return () => window.removeEventListener("focus", refreshFotoPerfil);
  }, []);


  const atualizarPreview = (url: string) => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };

  useEffect(() => {
    const dadosLocalStorage = localStorage.getItem("dadosUsuario");
    if (dadosLocalStorage) {
      try {
        const usuario = JSON.parse(dadosLocalStorage);
        setNomeUsuario(usuario.dscNome);
        setIdUsuario(usuario.seqUsuario);
        setFotoPerfil(usuario.imagemPerfil || '');
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }
  }, []);

  useEffect(() => {
    const handleUpdateFotoPerfil = () => {
      const dadosLocalStorage = localStorage.getItem("dadosUsuario");
      if (dadosLocalStorage) {
        const usuario = JSON.parse(dadosLocalStorage);
        setFotoPerfil(atualizarPreview(usuario.imagemPerfil || ''));
      }
    };
    window.addEventListener("fotoPerfilUpdated", handleUpdateFotoPerfil);
    return () => {
      window.removeEventListener("fotoPerfilUpdated", handleUpdateFotoPerfil);
    };
  }, []);

  function eventoSidebarAberta() {
    const dadosLocalStorage = localStorage.getItem("dadosUsuario");
    setIsSidebarAberta(prevState => !prevState);
    if (dadosLocalStorage) {
      const atualizarSidebar = {
        ...JSON.parse(dadosLocalStorage),
        sidebarFechada: isSidebarAberta,
      };
      localStorage.setItem("dadosUsuario", JSON.stringify(atualizarSidebar));
      window.dispatchEvent(new Event("sidebarAtualizada"));
    }
  }

  const atualizarPermissoes = () => {
    const permissaoAcessos = localStorage.getItem('permissaoAcesso');
    if (permissaoAcessos) {
      const parsedPermissaoAcesso = JSON.parse(permissaoAcessos);
      const mapItems = parsedPermissaoAcesso
        .filter((permissaoAcesso: any) => {
          const dscMenu = permissaoAcesso.menuDTO.dscMenu;
          return (
            dscMenu === 'Configuração' ||
            dscMenu === 'Publicação' ||
            dscMenu === 'Edição Cidade Inteligente'
          );
        })
        .map((permissaoAcesso: any) => {
          const dscMenu = permissaoAcesso.menuDTO.dscMenu;
          const codMenu = permissaoAcesso.menuDTO.codMenu;
          let path = '';
          let icon: (color: string) => JSX.Element = (color: string) => (
            <Icon as={Content} color={color} boxSize="28px" />
          );
  
          if (codMenu === 20000) {
            path = '/cms/configuracao';
            icon = (color: string) => <Icon as={IoSettingsOutline} color={color} boxSize="28px" />;
          } else if (codMenu === 10000) {
            path = '/cms/publicacao';
            icon = (color: string) => <Icon as={Content} boxSize="28px" style={{ fill: color }} />;
          } else if (codMenu === 30000) {
            path = '/cms/edicao-cidade-inteligente';
            icon = (color: string) => <Icon as={AiOutlineEdit} color={color} boxSize="28px" />;
          }
  
          return {
            seqPerfilMenu: permissaoAcesso.seqPerfilMenu,
            dscMenu: dscMenu,
            numRegistro: permissaoAcesso.numRegistro,
            path: path,
            icon: icon,
          };
        });
  
      // mapItems.push({
      //   seqPerfilMenu: 999,
      //   dscMenu: 'Relatórios',
      //   numRegistro: 999,
      //   path: '/cms/relatorios',
      //   icon: (color: string) => <Icon as={IoBarChartOutline} color={color} boxSize="28px" />,
      // });
  
      mapItems.push({
        seqPerfilMenu: 0,
        dscMenu: 'Sair',
        numRegistro: 0,
        path: 'logout',
        icon: (color: string) => <Icon as={IoLogOutOutline} color={color} boxSize="28px" />,
      });
  
      setPermisssaoAcessoCodMenuNulo(mapItems);
    }
  };

  useEffect(() => {
    atualizarPermissoes();
    const handleStorageChange = () => {
      atualizarPermissoes();
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleMudancaArquivo = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.type === "image/gif") {
      Swal.fire({
        icon: "error",
        title: "Arquivo inválido",
        text: "GIFs não são permitidos. Por favor, selecione outra imagem.",
        confirmButtonText: "OK",
        confirmButtonColor: "#1665D8",
      });
      return;
    }

    setLoading(true);

    setImagemUsuario(file);

    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        setFotoPerfil(reader.result);
      }
    };
    reader.readAsDataURL(file);

    const dadosLocalStorage = localStorage.getItem("dadosUsuario");
    let temFoto = false;
    let localFileName = "";
    if (dadosLocalStorage) {
      const usuario = JSON.parse(dadosLocalStorage);
      if (usuario.imagemPerfil && usuario.imagemPerfil.trim() !== "") {
        temFoto = true;
        const delimiter = "%2F";
        const index = usuario.imagemPerfil.lastIndexOf(delimiter);
        localFileName =
          index !== -1
            ? usuario.imagemPerfil.substring(index + delimiter.length)
            : usuario.imagemPerfil;
        setNomeCdn(localFileName);
      }
    }

    try {
      let finalCdnUrl = "";
      const nomePadrao = "imagemUsuario";
      const fileExtension = file.name.split(".").pop();
      let formData = new FormData();
      formData.append("file", file);

      if (!temFoto) {
        const fileNameToSend = `${nomePadrao}.${fileExtension}`;
        formData.append("fileName", fileNameToSend);
        formData.append("folderName", "imgUsuario");
        const cdnResponse = await api.inserirFotoPerfilNoCdn(formData);

        if (typeof cdnResponse === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnResponse.match(regex);
          if (match && match[0]) {
            finalCdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnResponse && cdnResponse.url) {
          finalCdnUrl = cdnResponse.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
      } else {
        formData = new FormData();
        const nomePasta = "imgUsuario";
        formData.append("file", file);
        formData.append("fileName", localFileName);
        formData.append("folderName", nomePasta);
        const cdnData = await api.editarFotoPerfilNoCdn(formData);
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            finalCdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          finalCdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
      }

      if (finalCdnUrl) {
        const updatedUrl = atualizarPreview(finalCdnUrl);
        setFotoPerfil(updatedUrl);

        const imageUrlToStore = finalCdnUrl.split('?')[0];
        const params = { seqUsuario: Number(idUsuario), imagem: imageUrlToStore };

        if (idUsuario) {
          if (temFoto) {
            await api.editarImagem(Number(idUsuario), params);
          } else {
            await api.inserirImagem(params);
          }
        }

        if (dadosLocalStorage) {
          const usuarioAtualizado = {
            ...JSON.parse(dadosLocalStorage),
            imagemPerfil: imageUrlToStore,
          };
          localStorage.setItem("dadosUsuario", JSON.stringify(usuarioAtualizado));
          window.dispatchEvent(new Event("fotoPerfilUpdated"));
        }
      }
    } catch (error) {
      console.error("Erro ao salvar imagem:", error);
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro!",
        text: "Erro ao salvar imagem. Tente novamente mais tarde.",
        confirmButtonColor: "#1665D8",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className={`sidebar-container ${!isSidebarAberta ? 'fechada' : ''}`}>
      <IconButton
        aria-label="Botão Sidebar"
        icon={isSidebarAberta ? <AiOutlineClose /> : <AiOutlineMenu />}
        onClick={() => eventoSidebarAberta()}
        className="fechar-sidebar-button"
        variant="ghost"
      />
      <Flex className="sidebar-flex">
        <Center className="sidebar-logo">
          <IconButton
            aria-label="Início"
            icon={<AiOutlineHome />}
            color="#1789FC"
            fontSize="24px"
            className="icon-button"
            variant="ghost"
            onClick={() => navigate(`/cms/inicio`)}
            _hover={{ transform: 'scale(1.1)' }}
          />
        </Center>

        {isSidebarAberta && (
          <Box className="profile-section">
            <Flex flexDir="column" alignItems="center">
              <Box role="group" position="relative" display="inline-block">
                <Circle className="profile-avatar" size="90px" border="2px solid #1789FC">
                  {(!fotoPerfil || fotoPerfil === '') ? (
                    <Icon as={IoPersonOutline} boxSize="50px" color="gray.400" />
                  ) : (
                    <Img
                      src={fotoPerfil}
                      alt="Avatar"
                      borderRadius="full"
                      objectFit="cover"
                      width="100%"
                      height="100%"
                    />
                  )}
                </Circle>
                <Box
                  position="absolute"
                  top="0"
                  left="0"
                  width="90px"
                  height="90px"
                  borderRadius="full"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  opacity={0}
                  transition="opacity 0.3s ease"
                  _groupHover={{ opacity: 1 }}
                  bg="rgba(128,128,128,0.5)"
                  cursor="pointer"
                  onClick={() => fileInputRef.current?.click()}
                >
                  <Icon as={IoCameraOutline} boxSize="8" color="white" />
                </Box>
              </Box>
              {nomeUsuario && <Text className="profile-name">{nomeUsuario}</Text>}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleMudancaArquivo}
              />
            </Flex>
          </Box>
        )}

        <Box>
          <List>
            {permisssaoAcessoCodMenuNulo.map((item, index) => {
              const isActive = location.pathname.startsWith(item.path);
              return (
                <ListItem className="menu-item" key={index}>
                  <button
                    onClick={() => {
                      if (item.path === 'logout') {
                        Swal.fire({
                          icon: 'question',
                          title: 'Deseja sair da aplicação?',
                          text: 'Você tem certeza que deseja sair?',
                          showCancelButton: true,
                          confirmButtonColor: '#1789FC',
                          confirmButtonText: 'Sim, desejo sair',
                          cancelButtonText: 'Não, desejo permanecer',
                          cancelButtonColor: '#EDF2F7',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            logout();
                          }
                        });
                      } else {
                        navigate(item.path);
                      }
                    }}                    
                    className={`menu-button ${isActive ? 'active' : ''}`}
                  >
                    {item.icon(isActive ? '#fff' : '#1789FC')}
                    {isSidebarAberta && (
                      <Text className={`menu-label ${isActive ? 'active' : ''}`}>
                        {item.dscMenu}
                      </Text>
                    )}
                  </button>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Flex>
    </Container>
  );
};

export default Sidebar;
